<template>
  <div class="email_form">
    <b-form @submit.prevent="send_email">
      <b-input-group size="sm" prepend="To:">
        <b-form-input v-model="to" required type="email"></b-form-input>
      </b-input-group>
      <b-input-group size="sm" prepend="Subject:" class="mt-2">
        <b-form-input v-model="subject" required></b-form-input>
      </b-input-group>
      <b-form-textarea
        required
        class="mt-2"
        rows="5"
        v-model="content"
      ></b-form-textarea>
      <b-form-file v-model="selected_file" class="mt-3" plain :disabled="is_uploading"></b-form-file>
      <p v-if="is_uploading">Uploading...</p>
      <div>
        <b-row
          class="mt-1 ml-1"
          v-for="(file, index) in attached_files"
          :key="index"
        >
          {{ file.filename }}
          <b-icon
            class="mt-1 ml-1 pointer"
            icon="x-circle"
            scale="1"
            variant="danger"
            @click="remove_file(index)"
          ></b-icon>
        </b-row>
      </div>
      <div class="modal-footer mt-2">
        <b-button
          :disabled="is_sending"
          variant="success"
          type="submit"
        >
          <span v-if="!is_sending">Send</span>
          <span v-if="is_sending">
            <b-spinner small type="grow"></b-spinner>
            Sending...
          </span>
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  props: {
    sender: Object,
    invoice_number: String,
    photo: Object,
  },
  data() {
    return {
      is_sending: false,
      is_uploading: false,
      uploaded_file_names: [],
      attached_files: [],
      selected_file: null,
      to: "@johnstonemart.com",
      subject: "",
      content: "",
    }
  },
  watch: {
    selected_file(new_selected_file) {
      if (this.selected_file != null) {
        this.is_uploading = true;
        const storageRef = firebase.storage().ref();

        const uploadingTask = storageRef
          .child('photo_email_attachments' + new_selected_file.name)
          .put(new_selected_file, new_selected_file.type);

        uploadingTask.then((data) => {
          data.ref.getDownloadURL().then((url) => {
            this.attached_files.push({
              filename: new_selected_file.name,
              path: url,
            });
            this.is_uploading = false;
          });
        });
      }
    },
  },
  methods: {
    send_email() {
      this.is_sending = true;
      var email = {
        from: this.sender.email,
        to: [this.to],
        message: {
          subject: this.subject,
          text: this.content + '\n' +
          '\n-----Photo Details-----' +
          '\nOrdered Date: ' + this.photo.dates[0].date + 
          '\nShape: ' + this.photo.shape + 
          '\nSize: ' + this.photo.size + 
          '\nQuantity: ' + this.photo.quantity + 
          '\nColour: ' + this.photo.colour,
          attachments: this.attached_files,
        },
      };

      firebase
        .firestore()
        .collection("mail")
        .add(email).then(() => {
          alert('Email sent successfully.');
          this.is_sending = false;
        });
    },
    remove_file(index) {
      this.attached_files.splice(index, 1);
      this.selected_file = null;
    },
  }
}
</script>
